<template>
	<div class="chat-message-markdown">
		<vue-markdown :source="message.markdown" :id="message.id" />
	</div>
</template>

<script>
import VueMarkdown from "vue-markdown";
export default {
	name: "ChatMessageMarkdown",
	components: {
		VueMarkdown,
	},
	props: {
		message: {
			type: Object,
			required: true,
		},
	},
	methods: {
		handleImageClick(url) {
			this.$emit("handle-image-view", { ...this.message, previewImage: url });
		},
	},
	mounted() {
		this.$nextTick(() => {
			const markdown = document.getElementById(this.message.id);
			markdown.addEventListener("click", (e) => {
				if (e.target.tagName === "IMG") {
					this.handleImageClick(e.target.currentSrc);
				}
			});
		});
	},
};
</script>

<style lang="less" scoped>
.chat-message-markdown {
	max-width: 100%;
	overflow-x: auto;
	/* 整个滚动条区域 */
	::-webkit-scrollbar {
		height: 6px !important; /* 水平滚动条高度 */
	}

	/* 滚动条轨道（背景） */
	::-webkit-scrollbar-track {
		opacity: 0;
		border-radius: 6px;
	}

	/deep/ img {
		max-width: 150px !important;
		object-fit: contain;
		cursor: pointer;
	}
	/deep/ * {
		word-break: break-all;
	}
}
</style>
